export default __webpack_public_path__ + "static/media/basis-icon.891e1f07.png";